import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import Cookie from 'js-cookie';
import Router from 'next/router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleResetPassword } from '../../redux/actions';
import SlideInModal from "../../containers/SlideInModal";
import InputList from '../InputList';
import Input from '../Input';

import { FormFooter, LoginButton, Message, } from './styles';
import { SignUpButton } from '../ForgotModal/styles';

const { Item } = InputList;
const { Heading, Description } = SlideInModal;

class NewPasswordModal extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    resetError: PropTypes.string,
    resetSuccess: PropTypes.bool,
    handleResetSubmit: PropTypes.func,
    resetToken: PropTypes.string,
    isValid: PropTypes.bool,
  };

  state = {
    newPassword: '',
    newPasswordConfirmation: '',
    errors: {},
    touched: {},
  };

  handleGoBackClick = () => {
    Router.push('/');
    Cookie.set('withLogin', 'true', { path: '/' });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleBlur = (e) => {
    const { name } = e.target;
    this.setState(prev => ({
      touched: { ...prev.touched, [name]: true },
    }), this.validate);
  };

  validate = () => {
    const { newPassword, newPasswordConfirmation } = this.state;
    const errors = {};

    if (!newPassword) {
      errors.newPassword = 'Password is required';
    } else if (newPassword.length < 8) {
      errors.newPassword = 'Password must be at least 8 characters';
    }

    if (!newPasswordConfirmation) {
      errors.newPasswordConfirmation = 'Please confirm your password';
    } else if (newPasswordConfirmation.length < 8) {
      errors.newPasswordConfirmation = 'Password must be at least 8 characters';
    } else if (newPassword !== newPasswordConfirmation) {
      errors.newPasswordConfirmation = 'Passwords must match';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { handleResetSubmit, resetToken } = this.props;
    const { newPassword } = this.state;

    this.setState({
      touched: { newPassword: true, newPasswordConfirmation: true },
    }, () => {
      if (this.validate()) {
        handleResetSubmit(newPassword, resetToken);
      }
    });
  };

  render() {
    const { handleGoBackClick, handleChange, handleBlur, handleSubmit } = this;
    const { name, resetError, resetSuccess, isValid } = this.props;
    const { newPassword, newPasswordConfirmation, errors, touched } = this.state;

    return (
      <SlideInModal name={name}>
        <Heading>
          Create new password
        </Heading>
        <Description />
        {isValid === true ? (
          <form onSubmit={handleSubmit}>
            <InputList>
              <Item>
                <Input
                  htmlType="password"
                  name="newPassword"
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  value={newPassword}
                  hasError={!!(errors.newPassword && touched.newPassword)}
                  placeholder={(touched.newPassword && errors.newPassword) || 'New password'}
                  floatingPlaceholder
                />
              </Item>
              <Item>
                <Input
                  htmlType="password"
                  name="newPasswordConfirmation"
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  value={newPasswordConfirmation}
                  hasError={!!(errors.newPasswordConfirmation && touched.newPasswordConfirmation)}
                  placeholder={(touched.newPasswordConfirmation && errors.newPasswordConfirmation) || 'Confirm new password'}
                  floatingPlaceholder
                />
              </Item>
            </InputList>
            {resetError && <Message type="error">{resetError}</Message>}
            {resetSuccess && <Message type="success">Password updated! You'll be redirected to the homepage shortly.</Message>}
            <FormFooter>
              <LoginButton type="submit" btnType="primary">
                Submit
              </LoginButton>
              <SignUpButton type="button" onClick={handleGoBackClick}>
                Remembered password?
              </SignUpButton>
            </FormFooter>
          </form>
        ) : isValid === false ? (
          <Fragment>
            <p>This link is invalid or has expired.</p>
            <LoginButton type="button" btnType="primary" onClick={() => Router.push('/')}>
              Go back
            </LoginButton>
          </Fragment>
        ) : null}

      </SlideInModal>
    )
  }
}

const mapStateToProps = state => ({
  resetError: state.user.errors.reset,
  resetSuccess: state.user.success.reset,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleResetSubmit: handleResetPassword,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewPasswordModal);
